<template>
    <div class="success_wrapper">
      <div class="result-modal" v-if="resultModalStatus" @touchmove.prevent>
        <div class="contact_wrapper">
          <img class="close" src="../assets/images/popup_close@3x.png" @click="closeModal">
          <img class="headIcon" src="../assets/images/popup_communication@3x.png">
          <h2>填写即时通讯联系方式</h2>
          <div class="contact">
            <div class="chat" @click="showContactModal">{{chatType}}<img src="../assets/images/global_down_arrow@3x.png"> </div>
            <input type="text" v-model="contact">
          </div>
          <div class="tips">
            <p><span>温馨提示：</span>为了工程师及时的联系到您并提供服务，请填写您的QQ或微信号</p>
          </div>
          <div class="btn" @click="submitContact">填写完成，前往查看订单详情</div>
        </div>

      </div>


      <div class="contact-modal" v-if="contactModalStatus" @touchmove.prevent>
        <ul class="type-list" :class="{'close':sheetStatus}">
          <li @click="selectContactType('QQ')">QQ【推荐】</li>
          <li @click="selectContactType('微信')">微信</li>
          <li @click="closeContactModal">取消</li>
        </ul>
      </div>

      <div class="main-wrapper">
        <mt-header fixed title="支付结果" style="background:#ffffff;color:#262626;">
          <mt-button icon="back" slot="left" @click="goBack"></mt-button>
        </mt-header>

        <div class="order_info_wrapper" v-if="order.id>0 && normalOrder">
          <img :src="order.detail[0].g_thumb" class="order_icon"/>
          <div class="order-info">
                <p class="g_description"> {{order.detail[0].g_description}} </p>
                <p class="gm_name"> {{order.detail[0].gm_name}} </p>
            </div>
          <div class="price">¥{{order.total}}</div>
        </div>

        <div class="order_info_wrapper" v-if="!normalOrder&&order.sorder_no">
          <img src="../assets/images/defaultService_100x100_@3x.png" class="order_icon"/>
          <div class="order-info">
                <p class="g_description">服务项目收费</p>
                <p class="gm_name">{{order.remark}} </p>
            </div>
          <div class="price">¥{{order.total}}</div>
        </div>


        <div class="pay_info" v-if="paySuccess  && order.status"> 
          <img src="../assets/images/pay_success_icon@3x.png" >
          <span class="pay_success">支付成功</span>
          <span class="pay_total" v-if="order.id>0 && orderno"> ¥{{order.total}}</span>
          <span class="pay_total" v-if="sorder_no && order.id>0"> ¥{{svr_gaol.total}}</span>
          <div class="btn" v-if="!sorder_no" @click="openModal">完成</div>
          <div class="btn" v-if="sorder_no" @click="goorderList">完成</div>
        </div>
        
        <div class="pay_info" v-if="!paySuccess"> 
          <img src="../assets/images/pay_error_icon@3x.png" >
          <span class="pay_error">支付失败</span>
          <span class="pay_total" v-if="sorder_no && order.id>0"> ¥{{svr_gaol.total}}</span>
          <span class="pay_total" v-if="order.id>0 && orderno"> ¥{{order.total}}</span>
          <div class="btn" @click="goorderList">完成</div>
        </div>
      </div>  
      
    </div>
</template>

<script>
import {Indicator} from 'mint-ui';
export default {
  name:"paysuccess",
  metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
  },
  data(){
    return{
      orderno:"",
      order:{},
      orderno_svr:"",
      sorder_no:"",
      svr_gaol:"",
      normalOrder:true,
      paySuccess:true,
      payTitle:"支付成功",
      clock:"",
      count:0,
      packageName:'',
      goodsCategory:'',
      payType:'',
      chats: ['QQ','微信'],
      chatType: 'QQ',
      resultModalStatus: false,
      contactModalStatus: false,
      sheetStatus: true,
      contact: ''
    }
  },
  methods:{
    submitContact(){
      let access_token = localStorage.access_token
      let data = {
        info: {
          orderno: this.orderno,
          qq: '',
          wxid: ''
        },
        access_token: access_token
      }
      if(this.contact){
        if(this.chatType == 'QQ'){
          data.info['qq'] = this.contact
        }else {
          data.info['wxid'] = this.contact
        }
        this.$store.dispatch('addOrderContact',data).then((res)=>{
          this.$router.push({name:'orderList'})
        })
      }else {
        alert('请填写联系方式')
      }
      
    },
    selectContactType(type){
      this.chatType = type
      this.closeContactModal()
    },
    closeContactModal(){
      let vm = this
      vm.sheetStatus = true
      setTimeout(function(){
        vm.contactModalStatus = false
      },300)
    },
    showContactModal(){
      let vm = this
      vm.contactModalStatus = true
      setTimeout(function(){
        vm.sheetStatus = false
      },300)
    },
    closeModal(){
      this.$router.push({name:'orderList'})
    },
    openModal(){
      if(!this.order.detail[0].qq || this.order.detail[0].qq == '000000'){
        this.resultModalStatus = true
      }else {
        this.$router.push({name:'orderList'})
      }
    },
    goBack(){
      this.$router.push({'name':"orderList"});
    },
    goorderList(){
      this.$router.push({'name':"orderList"})
    },
    goorderDetail(){
      this.$router.push({'name':"orderDetail",query:{'orderno':this.orderno}})
    },
    getOrderInfo(){
      let access_token = localStorage.access_token;
      let vm = this;
     
      if(this.normalOrder){    //订单支付
        let info = {
          'access_token':access_token,
          'orderno':vm.orderno
        };
        this.$store.dispatch("getOdinfo",info).then((res)=>{
          let data = res.data;
          if(data.code == 0){
            vm.order = data.res.order;
            let goodsCategory = this.order.detail[0].category==="1"?"数据恢复服务":"综合服务"
            if(vm.order.status == 3){
              vm.paySuccess = true;
              vm.payTitle = "支付成功"
              clearInterval(vm.clock)
              vm.sa_m_pay_result(
                this.order.orderno, 
                this.order.total_price, 
                this.order.adress.kxuid, 
                this.packageName, 
                goodsCategory, 
                this.order.detail[0].g_description, 
                this.payType, '支付成功',
                localStorage.huabei_num
                )
            }else{
              vm.paySuccess = false;
              vm.payTitle = "支付失败";
              vm.sa_m_pay_result(
                this.order.orderno, 
                this.order.total_price, 
                this.order.adress.kxuid, 
                this.packageName, 
                goodsCategory, 
                this.order.detail[0].g_description, 
                this.payType, '支付失败',
                localStorage.huabei_num
                )
            }
          }else if(data.code == 1200){
              new Promise(vm.refreshToken).then((token)=>{
                info.access_token = token;
                vm.$store.dispatch("getOdinfo",info).then((res)=>{
                   if(res.data.code == 0){  
                      vm.order = res.data.res.order;
                      let goodsCategory = this.order.detail[0].category==="1"?"数据恢复服务":"综合服务"
                      if(vm.order.status == 3){
                        vm.paySuccess = true;
                        vm.payTitle = "支付成功"
                        vm.sa_m_pay_result(
                          this.order.orderno, 
                          this.order.total_price, 
                          this.order.adress.kxuid, 
                          this.packageName, 
                          goodsCategory, 
                          this.order.detail[0].g_description, 
                          this.payType, '支付成功',
                          localStorage.huabei_num)
                        clearInterval(vm.clock)
                        // Indicator.close();
                      }else{
                        vm.paySuccess = false;
                        vm.payTitle = "支付失败"
                        vm.sa_m_pay_result(
                          this.order.orderno, 
                          this.order.total_price, 
                          this.order.adress.kxuid, 
                          this.packageName, 
                          goodsCategory, 
                          this.order.detail[0].g_description, 
                          this.payType, '支付失败',
                          localStorage.huabei_num
                          )
                      }
                   }else{
                      vm.$router.push({name:"login"})
                   }
                })
              })
          }else {
            vm.$router.push({name:"login"})
          }
        })
      }else{     //尾单支付
        let info = {
          'access_token':access_token,
          'sorder_no':vm.sorder_no
        };
        this.$store.dispatch("getSodingo",info).then((res)=>{
          let data = res.data;
          if(data.code == 0){
            vm.order = data.res;
            if(vm.order.status == 3){
              vm.paySuccess = true;
              vm.payTitle = "支付成功"
              clearInterval(vm.clock)
            }else{
                vm.paySuccess = false;
                vm.payTitle = "支付失败"
            }
          }else if(data.code == 1200){
              new Promise(vm.refreshToken).then((token)=>{
                info.access_token = token;
                vm.$store.dispatch("getSodingo",info).then((res)=>{
                   if(res.data.code == 0){  
                      vm.order = res.data.res;
                      if(vm.order.status == 3){
                        vm.paySuccess = true;
                        vm.payTitle = "支付成功"
                        clearInterval(vm.clock)
                      }else{
                        vm.paySuccess = false;
                        vm.payTitle = "支付失败"
                      }
                   }else{
                      vm.$router.push({name:"login"})
                   }
                   
                })
              })
          }else {
            vm.$router.push({name:"login"})
          }
        })
      }
      
    }
  },
  created(){
    this.packageName = sessionStorage.packageName;
    this.payType = sessionStorage.payType;
    this.orderno = this.$route.query.orderno;
    let sorder_no = this.$route.query.sorder_no;
    if(sorder_no){
      this.normalOrder = false;
      this.sorder_no = sorder_no;
      
    }else{
      this.normalOrder = true;
    }
    this.getOrderInfo();
    let vm = this;
    vm.clock = setInterval(function(){
      vm.count = vm.count + 1;
      vm.getOrderInfo();
      if(vm.count == 2){
        clearInterval(vm.clock)
      }
    },1000)
  },
  mounted(){
  },
  components:{
  },
  destroyed(){
    localStorage.removeItem('huabei_num')
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/PayResult.vue